import React, { ReactNode } from "react";
import classNames from "classnames";

import styles from "../input.module.scss";

export interface NumberInputProps {
  className?: string;
  registration: any;
  placeholder?: string;
  error?: string | false;
  isRequired?: boolean;
  label?: string;
  disabled?: boolean;
  icon?: ReactNode;
}
export const NumberInput: React.FC<NumberInputProps> = ({
  className,
  registration,
  placeholder = "placeholder",
  error,
  isRequired = false,
  disabled,
  label,
  icon,
}) => {
  const inputClass = classNames(className, styles.container);
  const inputContainerClass = classNames(
    styles.input_container,
    disabled && styles.disabled
  );
  return (
    <div className={inputClass}>
      <div className={styles.label}>
        {isRequired && <span className="text-danger"> * </span>}
        {icon}
        {label && <span>{label}</span>}
      </div>
      <div className={inputContainerClass}>
        <input
          type={"number"}
          {...registration}
          onWheel={(e) => (e.target as HTMLInputElement).blur()}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>

      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};
